// import {
//   FiHome, FiUsers, FiCreditCard,
//   FiActivity, FiTrendingUp, FiBell,
//   FiRadio, FiSettings, FiFlag, FiMail, FiX, FiCamera
// } from "react-icons/fi";
// import { getUserRole } from "./utilities/getUserRole";
// import { FaHistory } from "react-icons/fa";
// import { Link, useLocation } from "react-router-dom";
// import { useState, useEffect } from "react";
// import axios from "axios";
// import { db } from "../lib/firebase";
// import { collection, query as fsQuery, where, getCountFromServer } from "firebase/firestore";
// import { useSidebar } from "./Layout";

// // Updated navigation according to requirements
// const navItems = [
//   { label: "Dashboard", path: "/", icon: <FiHome /> },
//   { label: "Users", path: "/users", icon: <FiUsers /> },
//   { label: "Subscription Plans", path: "/subscription-plans", icon: <FiCreditCard /> },
//   { label: "Selfie Approvals", path: "/selfie-approvals", icon: <FiCamera /> },
//   { label: "Call History", path: "/call-transactions", icon: <FiActivity /> },
//   { label: "Subscription History", path: "/subscription-history", icon: <FaHistory /> },
//   { label: "User Activity", path: "/user-activity", icon: <FiRadio /> },
//   { label: "Analytics", path: "/analytics", icon: <FiTrendingUp /> },
//   { label: "Reports", path: "/reports", icon: <FiFlag /> },
//   { label: "Contact Us", path: "/contact-us", icon: <FiMail /> },
//   { label: "Admin Settings", path: "/admin-settings", icon: <FiSettings /> },
//   { label: "Push Notifications", path: "/push-notifications", icon: <FiBell /> },
// ];

// const Sidebar = () => {
//   const location = useLocation();
//   const { isOpen, close } = useSidebar();
//   const userData = getUserRole() || {};
//   const userRole = userData.role;
//   const userEmail = (typeof userData.email === "string" ? userData.email : "").toLowerCase();

//   const [openContactMessages, setOpenContactMessages] = useState(0);
//   useEffect(() => {
//     let mounted = true;
//     const fetchOpenContacts = async () => {
//       try {
//         if (!db) return;
//         const base = collection(db, "admin_support_chats");
//         const openSnap = await getCountFromServer(fsQuery(base, where("status", "==", "OPEN")));
//         const count = openSnap.data().count || 0;
//         if (mounted) setOpenContactMessages(count);
//       } catch (_) {
//         if (mounted) setOpenContactMessages(0);
//       }
//     };
//     fetchOpenContacts();
//     const t = setInterval(fetchOpenContacts, 30000);
//     return () => {
//       mounted = false;
//       clearInterval(t);
//     };
//   }, []);

//   const [pendingSelfieApprovals, setPendingSelfieApprovals] = useState(0);
//   useEffect(() => {
//     let mounted = true;
//     const fetchPending = async () => {
//       try {
//         const res = await axios.get("/api/v1/app/voice-verification/statistics");
//         const payload = res?.data || {};
//         const count = Number(payload?.data?.statistics?.verificationStatus?.pending?.count || 0);
//         if (mounted) setPendingSelfieApprovals(Number.isFinite(count) ? count : 0);
//       } catch (_) {
//         if (mounted) setPendingSelfieApprovals(0);
//       }
//     };
//     fetchPending();
//     const t = setInterval(fetchPending, 30000);
//     return () => {
//       mounted = false;
//       clearInterval(t);
//     };
//   }, []);

//   const [pendingReports, setPendingReports] = useState(0);
//   useEffect(() => {
//     let mounted = true;
//     const fetchPending = async () => {
//       try {
//         const res = await axios.get("/api/v1/app/user-reports/counts");
//         const count = Number(res?.data?.data?.pendingReports || 0);
//         if (mounted) setPendingReports(Number.isFinite(count) ? count : 0);
//       } catch (_) {
//         if (mounted) setPendingReports(0);
//       }
//     };
//     fetchPending();
//     const t = setInterval(fetchPending, 30000);
//     return () => {
//       mounted = false;
//       clearInterval(t);
//     };
//   }, []);

//   const NavLink = ({ item, active, children }) => {
//     const isActive =
//       active || location.pathname === item.path || location.pathname.startsWith(item.path + "/");

//     return (
//       <Link
//         to={item.path}
//         onClick={close}
//         className={`group flex items-center gap-3 px-4 py-2.5 rounded-xl transition-all duration-300 min-w-0 relative ${
//           isActive
//             ? "text-white shadow-lg"
//             : "text-cyan-100/70 hover:text-white hover:bg-cyan-400/[0.08]"
//         }`}
//         style={isActive ? {
//           background: "linear-gradient(135deg, rgba(6, 182, 212, 0.45), rgba(59, 130, 246, 0.5))",
//           backdropFilter: "blur(12px)",
//           border: "1px solid rgba(103, 232, 249, 0.35)",
//           boxShadow: "0 8px 24px rgba(6, 182, 212, 0.25), inset 0 1px 2px rgba(255, 255, 255, 0.3)",
//         } : {}}
//       >
//         {isActive && (
//           <span
//             className="absolute left-0 top-1/2 -translate-y-1/2 w-1.5 h-5 rounded-r-full bg-cyan-300 shadow-[0_0_10px_#22d3ee]"
//             aria-hidden
//           />
//         )}
//         <span className={`text-lg flex-shrink-0 transition-transform duration-200 ${isActive ? "scale-110 text-cyan-300" : "group-hover:scale-110 group-hover:text-cyan-300"}`}>
//           {item.icon}
//         </span>
//         <span className="truncate flex-1 text-sm font-medium tracking-wide">{children || item.label}</span>

//         {item.label === "Selfie Approvals" && pendingSelfieApprovals > 0 && (
//           <span className={`ml-auto text-[10px] font-bold px-2 py-0.5 rounded-full ${
//             isActive ? "bg-white text-cyan-900 shadow-sm" : "bg-gradient-to-r from-cyan-400 to-blue-500 text-white"
//           }`}>
//             {pendingSelfieApprovals}
//           </span>
//         )}
//         {item.label === "Contact Us" && openContactMessages > 0 && (
//           <span className={`ml-auto text-[10px] font-bold px-2 py-0.5 rounded-full ${
//             isActive ? "bg-white text-cyan-900 shadow-sm" : "bg-gradient-to-r from-cyan-400 to-blue-500 text-white"
//           }`}>
//             {openContactMessages}
//           </span>
//         )}
//         {item.label === "Reports" && pendingReports > 0 && (
//           <span className={`ml-auto text-[10px] font-bold px-2 py-0.5 rounded-full ${
//             isActive ? "bg-white text-cyan-900 shadow-sm" : "bg-gradient-to-r from-cyan-400 to-blue-500 text-white"
//           }`}>
//             {pendingReports}
//           </span>
//         )}
//       </Link>
//     );
//   };

//   return (
//     <>
//       {isOpen && (
//         <div
//           className="fixed inset-0 z-40 lg:hidden"
//           style={{ background: "rgba(3, 10, 26, 0.75)", backdropFilter: "blur(8px)" }}
//           onClick={close}
//           aria-hidden
//         />
//       )}
//       <aside
//         className={`fixed top-0 left-0 h-screen w-72 z-50 flex flex-col justify-between
//           transition-transform duration-300 ease-out
//           sidebar-desktop ${isOpen ? "sidebar-open" : ""}`}
//         style={{
//           background: "linear-gradient(180deg, rgba(7, 21, 56, 0.88) 0%, rgba(3, 11, 30, 0.94) 100%)",
//           backdropFilter: "blur(18px)",
//           WebkitBackdropFilter: "blur(18px)",
//           borderRight: "1px solid rgba(56, 189, 248, 0.2)",
//           boxShadow: "10px 0 35px rgba(2, 6, 23, 0.65), inset -1px 0 1px rgba(255, 255, 255, 0.05)",
//         }}
//       >
//         <div className="flex flex-col h-full overflow-hidden">
//           {/* Logo Section */}
//           <div className="flex items-center justify-between px-5 py-5" style={{ borderBottom: "1px solid rgba(56, 189, 248, 0.15)" }}>
//             <Link to="/" className="flex items-center gap-3 py-2">
//               <div className="relative">
//                 <img
//                   src="/spoonland-logo.jpeg"
//                   alt="Spoonland App"
//                   className="w-12 h-12 rounded-2xl object-cover"
//                   style={{
//                     border: "1.5px solid rgba(34, 211, 238, 0.6)",
//                     boxShadow: "0 0 20px rgba(6, 182, 212, 0.45)",
//                   }}
//                 />
//                 <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full bg-cyan-400 border-2 border-[#030b1e] shadow-[0_0_8px_#22d3ee]" />
//               </div>
//               <div className="leading-tight">
//                 <p className="font-extrabold text-lg tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 via-blue-200 to-white">
//                   Spoonland
//                 </p>
//                 <p className="text-[10px] tracking-[0.2em] font-semibold uppercase text-cyan-400/80">Oceanic Admin</p>
//               </div>
//             </Link>
//             <button
//               className="lg:hidden text-cyan-200 hover:text-white p-1 rounded-lg hover:bg-white/10"
//               onClick={close}
//               aria-label="Close sidebar"
//             >
//               <FiX size={20} />
//             </button>
//           </div>

//           {/* Navigation Items */}
//           <nav className="flex-1 overflow-y-auto px-3 py-4 flex flex-col gap-1.5" style={{ scrollbarGutter: "stable" }}>
//             {navItems
//               .filter(item => {
//                 if (item.showOnlyForEmail) {
//                   const allowedEmails = Array.isArray(item.showOnlyForEmail) ? item.showOnlyForEmail : [item.showOnlyForEmail];
//                   return allowedEmails.some(email => email.toLowerCase() === userEmail);
//                 }
//                 return !item.role || item.role === userRole;
//               })
//               .map((item) => (
//                 <NavLink key={item.label} item={item}>{item.label}</NavLink>
//               ))}

//             {/* Profile / Bottom Card */}
//             <div className="mt-auto pt-4 px-2">
//               <div
//                 className="rounded-2xl p-4 text-center relative overflow-hidden"
//                 style={{
//                   background: "linear-gradient(135deg, rgba(14, 116, 144, 0.25) 0%, rgba(30, 58, 138, 0.3) 100%)",
//                   backdropFilter: "blur(12px)",
//                   border: "1px solid rgba(56, 189, 248, 0.25)",
//                   boxShadow: "0 8px 32px rgba(0, 0, 0, 0.35), inset 0 1px 1px rgba(255, 255, 255, 0.15)",
//                 }}
//               >
//                 <div className="absolute -top-12 -left-12 w-24 h-24 bg-cyan-400/20 rounded-full blur-xl pointer-events-none" />
//                 <p className="font-semibold mb-0.5 text-sm text-white">Welcome back 🌊</p>
//                 <p className="text-xs text-cyan-200/80 truncate">
//                   {userData?.fullName || "Admin"}
//                 </p>
//               </div>
//             </div>
//           </nav>
//         </div>
//       </aside>
//     </>
//   );
// };

// export default Sidebar;

import {
  FiHome, FiUsers, FiCreditCard,
  FiBell, FiSettings, FiFlag, FiX, 
  FiCamera, FiImage,
  FiActivity,
  FiRadio,
  FiMusic,
  FiTrendingUp,
  FiDollarSign,
  FiAward
} from "react-icons/fi";
import { getUserRole } from "./utilities/getUserRole";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { useSidebar } from "./Layout";
import { FaHistory } from "react-icons/fa";

// Updated navigation according to the Social Connection project requirements
const navItems = [
  { label: "Dashboard", path: "/", icon: <FiHome /> },
  { label: "User Management", path: "/users", icon: <FiUsers /> },
  { label: "Partners", path: "/partners", icon: <FiUsers /> },
  { label: "User Verification", path: "/selfie-approvals", icon: <FiCamera /> },
  { label: "User Badges", path: "/badges", icon: <FiAward /> },
  { label: "Subscriptions", path: "/subscription-plans", icon: <FiCreditCard /> },
  { label: "Purchase History", path: "/purchase-history", icon: <FaHistory /> },
  { label: "Call History", path: "/call-transactions", icon: <FiActivity /> },
  { label: "User Activity", path: "/user-activity", icon: <FiRadio /> },
  { label: "User Analytics", path: "/analytics", icon: <FiTrendingUp /> },
  { label: "Revenue", path: "/revenue", icon: <FiDollarSign /> },
  { label: "Reports & Moderation", path: "/reports", icon: <FiFlag /> },
  { label: "Banners", path: "/banners", icon: <FiImage /> },
  { label: "Push Notifications", path: "/push-notifications", icon: <FiBell /> },
  { label: "Settings", path: "/settings", icon: <FiSettings /> },
];

const Sidebar = () => {
  const location = useLocation();
  const { isOpen, close } = useSidebar();
  const userData = getUserRole() || {};
  const userRole = userData.role;
  const userEmail = (typeof userData.email === "string" ? userData.email : "").toLowerCase();

  // State for notification badges
  const [pendingSelfieApprovals, setPendingSelfieApprovals] = useState(0);
  const [pendingReports, setPendingReports] = useState(0);

  // Fetch pending selfies
  useEffect(() => {
    let mounted = true;
    const fetchPendingSelfies = async () => {
      try {
        // Note: You may need to update this API endpoint to your new selfie verification route
        const res = await axios.get("/api/v1/app/selfie-verification/statistics");
        const payload = res?.data || {};
        const count = Number(payload?.data?.statistics?.verificationStatus?.pending?.count || 0);
        if (mounted) setPendingSelfieApprovals(Number.isFinite(count) ? count : 0);
      } catch (_) {
        if (mounted) setPendingSelfieApprovals(0);
      }
    };
    fetchPendingSelfies();
    const t = setInterval(fetchPendingSelfies, 30000);
    return () => {
      mounted = false;
      clearInterval(t);
    };
  }, []);

  // Fetch pending reports
  useEffect(() => {
    let mounted = true;
    const fetchPendingReports = async () => {
      try {
        const res = await axios.get("/api/v1/app/user-reports/counts");
        const count = Number(res?.data?.data?.pendingReports || 0);
        if (mounted) setPendingReports(Number.isFinite(count) ? count : 0);
      } catch (_) {
        if (mounted) setPendingReports(0);
      }
    };
    fetchPendingReports();
    const t = setInterval(fetchPendingReports, 30000);
    return () => {
      mounted = false;
      clearInterval(t);
    };
  }, []);

  const NavLink = ({ item, active, children }) => {
    const isActive =
      active || location.pathname === item.path || location.pathname.startsWith(item.path + "/");

    return (
      <Link
        to={item.path}
        onClick={close}
        className={`group flex items-center gap-3 px-4 py-2.5 rounded-xl transition-all duration-300 min-w-0 relative ${
          isActive
            ? "text-white shadow-lg"
            : "text-cyan-100/70 hover:text-white hover:bg-cyan-400/[0.08]"
        }`}
        style={isActive ? {
          background: "linear-gradient(135deg, rgba(6, 182, 212, 0.45), rgba(59, 130, 246, 0.5))",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(103, 232, 249, 0.35)",
          boxShadow: "0 8px 24px rgba(6, 182, 212, 0.25), inset 0 1px 2px rgba(255, 255, 255, 0.3)",
        } : {}}
      >
        {isActive && (
          <span
            className="absolute left-0 top-1/2 -translate-y-1/2 w-1.5 h-5 rounded-r-full bg-cyan-300 shadow-[0_0_10px_#22d3ee]"
            aria-hidden
          />
        )}
        <span className={`text-lg flex-shrink-0 transition-transform duration-200 ${isActive ? "scale-110 text-cyan-300" : "group-hover:scale-110 group-hover:text-cyan-300"}`}>
          {item.icon}
        </span>
        <span className="truncate flex-1 text-sm font-medium tracking-wide">{children || item.label}</span>

        {/* Dynamic Badges */}
        {item.label === "Selfie Verification" && pendingSelfieApprovals > 0 && (
          <span className={`ml-auto text-[10px] font-bold px-2 py-0.5 rounded-full ${
            isActive ? "bg-white text-cyan-900 shadow-sm" : "bg-gradient-to-r from-cyan-400 to-blue-500 text-white"
          }`}>
            {pendingSelfieApprovals}
          </span>
        )}
        {item.label === "Reports & Moderation" && pendingReports > 0 && (
          <span className={`ml-auto text-[10px] font-bold px-2 py-0.5 rounded-full ${
            isActive ? "bg-white text-cyan-900 shadow-sm" : "bg-gradient-to-r from-cyan-400 to-blue-500 text-white"
          }`}>
            {pendingReports}
          </span>
        )}
      </Link>
    );
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-40 lg:hidden"
          style={{ background: "rgba(3, 10, 26, 0.75)", backdropFilter: "blur(8px)" }}
          onClick={close}
          aria-hidden
        />
      )}
      <aside
        className={`fixed top-0 left-0 h-screen w-72 z-50 flex flex-col justify-between
          transition-transform duration-300 ease-out
          sidebar-desktop ${isOpen ? "sidebar-open" : ""}`}
        style={{
          background: "linear-gradient(180deg, rgba(7, 21, 56, 0.88) 0%, rgba(3, 11, 30, 0.94) 100%)",
          backdropFilter: "blur(18px)",
          WebkitBackdropFilter: "blur(18px)",
          borderRight: "1px solid rgba(56, 189, 248, 0.2)",
          boxShadow: "10px 0 35px rgba(2, 6, 23, 0.65), inset -1px 0 1px rgba(255, 255, 255, 0.05)",
        }}
      >
        <div className="flex flex-col h-full overflow-hidden">
          {/* Logo Section */}
          <div className="flex items-center justify-between px-5 py-5" style={{ borderBottom: "1px solid rgba(56, 189, 248, 0.15)" }}>
            <Link to="/" className="flex items-center gap-3 py-2">
              <div className="relative">
                <img
                  src="/spoonland-logo.jpeg" // Reverted to .jpeg per your prompt
                  alt="Spoonland App"
                  className="w-12 h-12 rounded-2xl object-cover"
                  style={{
                    border: "1.5px solid rgba(34, 211, 238, 0.6)",
                    boxShadow: "0 0 20px rgba(6, 182, 212, 0.45)",
                  }}
                />
                <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full bg-cyan-400 border-2 border-[#030b1e] shadow-[0_0_8px_#22d3ee]" />
              </div>
              <div className="leading-tight">
                <p className="font-extrabold text-lg tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 via-blue-200 to-white">
                  Spoonland
                </p>
                <p className="text-[10px] tracking-[0.2em] font-semibold uppercase text-cyan-400/80">Admin Panel</p>
              </div>
            </Link>
            <button
              className="lg:hidden text-cyan-200 hover:text-white p-1 rounded-lg hover:bg-white/10"
              onClick={close}
              aria-label="Close sidebar"
            >
              <FiX size={20} />
            </button>
          </div>

          {/* Navigation Items */}
          <nav className="flex-1 overflow-y-auto px-3 py-4 flex flex-col gap-1.5" style={{ scrollbarGutter: "stable" }}>
            {navItems
              .filter(item => {
                if (item.showOnlyForEmail) {
                  const allowedEmails = Array.isArray(item.showOnlyForEmail) ? item.showOnlyForEmail : [item.showOnlyForEmail];
                  return allowedEmails.some(email => email.toLowerCase() === userEmail);
                }
                return !item.role || item.role === userRole;
              })
              .map((item) => (
                <NavLink key={item.label} item={item}>{item.label}</NavLink>
              ))}

            {/* Profile / Bottom Card */}
            <div className="mt-auto pt-4 px-2">
              <div
                className="rounded-2xl p-4 text-center relative overflow-hidden"
                style={{
                  background: "linear-gradient(135deg, rgba(14, 116, 144, 0.25) 0%, rgba(30, 58, 138, 0.3) 100%)",
                  backdropFilter: "blur(12px)",
                  border: "1px solid rgba(56, 189, 248, 0.25)",
                  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.35), inset 0 1px 1px rgba(255, 255, 255, 0.15)",
                }}
              >
                <div className="absolute -top-12 -left-12 w-24 h-24 bg-cyan-400/20 rounded-full blur-xl pointer-events-none" />
                <p className="font-semibold mb-0.5 text-sm text-white">Welcome back 🌊</p>
                <p className="text-xs text-cyan-200/80 truncate">
                  {userData?.fullName || "Admin"}
                </p>
              </div>
            </div>
          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
